export function normalizeAvatarSrc(raw) {
  if (raw == null || typeof raw !== 'string') return null
  const trimmed = raw.trim()
  return trimmed.length > 0 ? trimmed : null
}

export function avatarInitial(name) {
  const trimmed = typeof name === 'string' ? name.trim() : ''
  return (trimmed[0] || '?').toUpperCase()
}
